export const UPDATE_BREAKPOINTS = "UPDATE_BREAKPOINTS";

export const updateBreakpoints = payload => ({
  type: UPDATE_BREAKPOINTS,
  payload,
});
